// extracted by mini-css-extract-plugin
module.exports = {"imageBlock":"ImageBlock_imageBlock__sVxaO","image":"ImageBlock_image__bpQxY","shimmer":"ImageBlock_shimmer__4UKpW"};